import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import Akar from './app/Akar'
import { bacaParamTampilan } from './app/tampilan'

// `?ui=` dibaca dan dibuang dari alamat SEBELUM router mana pun dibuat.
bacaParamTampilan()

// Sesudah deploy, tab yang masih terbuka memegang `index.html` versi lama dan meminta
// potongan JS yang namanya sudah tidak ada. Halamannya dimuat ulang supaya mengambil
// versi baru. Cap waktu di sessionStorage mencegahnya berputar: kalau muat ulang
// barusan tidak menolong, galatnya dibiarkan sampai ke layar.
window.addEventListener('vite:preloadError', (e) => {
  const KUNCI = 'smova.muatUlang'
  try {
    const terakhir = Number(sessionStorage.getItem(KUNCI)) || 0
    if (Date.now() - terakhir < 30_000) return
    sessionStorage.setItem(KUNCI, String(Date.now()))
  } catch {
    return
  }
  e.preventDefault()
  window.location.reload()
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Akar />
  </React.StrictMode>,
)
